import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { useMemo } from "react";

import { PaintConfiguration } from "@/utils/productConfiguration/visuals/paintConfiguration/paintConfigurator.types";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";
import { ProductsContextProvider } from "./context/products.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const { state } = usePaintConfiguratorContext();

    const encodedState = useMemo(() => {
        const {
            collection,
            colorHex,
            colorId,
            colorName,
            deliveryType,
            family,
            finish,
            volume
        } = state;

        if (!colorId || !colorHex || !colorName || !family || !collection) {
            return undefined;
        }

        const outPutState: PaintConfiguration = {
            paintInfo: {
                collection,
                colorHex,
                colorName,
                colorId,
                family,
                finish,
                volume,
                deliveryType
            }
        };
        const encodedState = btoa(
            encodeURIComponent(JSON.stringify(outPutState))
        );
        return encodedState;
    }, [state]);

    return (
        <ProductsContextProvider
            colorId={state.colorId}
            urlState={encodedState}
        >
            {children}
        </ProductsContextProvider>
    );
};

export { Base };
